import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 流程管理标签页切换name
    proManActive: "1",
    // 路由
    asyncRouters: [],
    // token
    ebd_token: null,
    // 用户信息
    userInfo: {},
    // cms面包屑导航title
    cmsTitle: null,
    // 登录项目类型
    project: null,
    // 登录用户类型
    userFlag: null,
    // 是否请求工作台接口标识
    isQueryHome: 0
  },
  mutations: {
    // 存储流程管理标签页name
    SET_ACTIVE(state, data) {
      state.proManActive = data;
    },
    // 路由存储
    SET_ROUTER(state, data) {
      state.asyncRouters = data;
      sessionStorage.setItem("asyncRouters", JSON.stringify(data));
    },
    // token存储
    SET_TOKEN(state, data) {
      state.ebd_token = data;
      sessionStorage.setItem("ebd_token", data);
    },
    // 储存用户信息
    SET_USERINFO(state, data) {
      state.userInfo = data;
      sessionStorage.setItem("userInfo", JSON.stringify(data));
    },
    // 储存登录类型
    SET_LOGINTYPE(state, data) {
      state.userInfo = data;
      sessionStorage.setItem("loginType", data);
    },
    // 储存用户类型
    SET_USERTYPE(state, data) {
      state.userInfo = data;
      sessionStorage.setItem("userType", data);
    },
    // 储存项目登录类型
    SET_PROJECT(state, data) {
      state.project = data;
      sessionStorage.setItem("project", data);
    },
    // 储存用户类型
    SET_USERFLAG(state, data) {
      state.userFlag = data;
      sessionStorage.setItem("userFlag", data);
    },
    // 储存cms面包屑导航title
    SET_CMSTITLE(state, data) {
      state.cmsTitle = data;
    },
    // 储存是否请求工作台接口标识
    SET_QUERYHOME(state, data) {
      state.isQueryHome = data;
    },
  },
  actions: {},
  modules: {}
});
